var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavoritesSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.247,
    height: 29.495,
    viewBox: "0 0 32.247 29.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-837.497 -579.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M847.1,579.875a9.6,9.6,0,0,0-9.6,9.6c0,12.52,16.124,19.893,16.124,19.893V582.445A9.556,9.556,0,0,0,847.1,579.875Z",
    transform: "translate(0 0)",
    fill: "#e33d31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.018,579.875a9.6,9.6,0,0,1,9.6,9.6c0,12.52-16.123,19.893-16.123,19.893V582.445A9.552,9.552,0,0,1,868.018,579.875Z",
    transform: "translate(-7.877 0)",
    fill: "#e75748"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavoritesSelected);
export default __webpack_public_path__ + "static/media/icon_favorites_selected.7aa51888f9a46e049b0f88d2d9ad1792.svg";
export { ForwardRef as ReactComponent };